<template>
  <b-container class="page-container" style="background-color: #f0f0f0" fluid>
    <AustraliaConfCheckout :combos="combos" />
  </b-container>
</template>
<style>

</style>

<script>
import AustraliaConfCheckout from "@/components/checkout/australiaconf/AustraliaConfCheckout.vue";

export default {
  title: 'Dropsmart Australia Conference Bonus Checkout',
  name: "AustraliaConf",
  props: ["combos"],
  components: {
    AustraliaConfCheckout
  },
};
</script>
